import { decode } from 'jsonwebtoken';
import { z } from 'zod';

const AnonAuthToken = z.object({
  provider_id: z.string(),
  iss: z.string().url(),
  aud: z.string(),
  auth_time: z.number(),
  user_id: z.string(),
  sub: z.string(),
  iat: z.number(),
  exp: z.number(),
});

const AuthTokenSchema = z.object({
  iss: z.string(),
  aud: z.string(),
  auth_time: z.number(),
  user_id: z.string(),
  sub: z.string(),
  iat: z.number(),
  exp: z.number(),
  email: z.string().optional(),
  email_verified: z.boolean().default(false),
  // firebase: z
  //   .object({
  //     identities: z.record(z.array(z.string())).nullish(),
  //     sign_in_provider: z.string().nullish(),
  //   })
  //   .nullish(),
});

export function decodeAuthToken(token: string) {
  if (!token) {
    return;
  }

  const tokenBody = decode(token);
  if (!tokenBody) {
    return;
  }

  const authTokenSafeParseResponse = AuthTokenSchema.safeParse(tokenBody);
  if (authTokenSafeParseResponse.success) {
    return authTokenSafeParseResponse.data;
  }
}

export function decodeAnonAuthToken(token: string) {
  if (!token) {
    return;
  }

  const tokenBody = decode(token);
  if (!tokenBody) {
    return;
  }

  const anonAuthTokenSafeParseResponse = AnonAuthToken.safeParse(tokenBody);

  return anonAuthTokenSafeParseResponse.data;
}
